import { FeedbackSuccess } from './FeedbackSuccess';
import { FeedbackError } from './FeedbackError';

export const Modal = {
  Success: FeedbackSuccess,
  Error: FeedbackError
};
